// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-label {\n  color: blue;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.advance-btn {\n  width: 100%;\n  max-width: 512px;\n  margin-left: auto;\n  margin-right: auto;\n}", ""]);
// Exports
module.exports = exports;
